import { render, staticRenderFns } from "./inscription-list-filter.vue?vue&type=template&id=17af5881&"
import script from "./inscription-list-filter.vue?vue&type=script&lang=js&"
export * from "./inscription-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports